var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-group',{ref:"listGroup",staticClass:"schedule-list-item schedule-list-item--with-details",attrs:{"append-icon":false},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('ScheduleListItem',{attrs:{"shift":_vm.shift}})]},proxy:true}])},[_c('EventList',{staticClass:"ml-4",attrs:{"hide-delete":"","events":_vm.shift.events}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }